import { AbstractControl, ValidationErrors } from '@angular/forms';

export function isNumberValidator( ctrl: AbstractControl ): ValidationErrors | null {
  return typeof ctrl.value !== 'number'
    || Number.isNaN( Number.parseInt( ctrl.value.toString(), 10 ) ) ?
    { 'isNumber': { value: ctrl.value } } : null;
}
